import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom";
import { I18nextProvider } from "react-i18next";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import "antd/dist/antd.css";

import Router from "./router";
import i18n from "./translation";

// Custom theme to match your brand colors
const theme = extendTheme({
  colors: {
    brand: {
      50: "#FFF5E6",
      100: "#FFE6B3", 
      200: "#FFD580",
      300: "#FFC54D",
      400: "#FFB51A",
      500: "#EFA81F", // Your golden yellow
      600: "#D4951C",
      700: "#B87F18",
      800: "#9D6814",
      900: "#82510F",
    },
    coral: {
      50: "#FFF2F0",
      100: "#FFD6CC",
      200: "#FFB8A8", 
      300: "#FF9A84",
      400: "#FF7C60",
      500: "#DA726A", // Your coral color
      600: "#C4665E",
      700: "#AE5A52",
      800: "#984E46", 
      900: "#82423A",
    },
    navy: {
      500: "#2E186A", // Your navy color
    },
  },
  fonts: {
    heading: "'Motiva Sans Bold', serif",
    body: "'Motiva Sans Light', sans-serif",
  },
  styles: {
    global: {
      body: {
        bg: "white",
        color: "coral.500",
      },
    },
  },
});

const App = () => (
  <ChakraProvider theme={theme}>
    <BrowserRouter>
      <I18nextProvider i18n={i18n}>
        <Router />
      </I18nextProvider>
    </BrowserRouter>
  </ChakraProvider>
);

ReactDOM.render(<App />, document.getElementById("root"));
